export default __webpack_public_path__ + "static/privacy-807fd2b210813ed25c9994edab3112c2.jpg";